// extracted by mini-css-extract-plugin
export default {"slide_title":"MovieSlide_slide_title__zXUQm","carousel":"MovieSlide_carousel__LxsaO","movieSlide":"MovieSlide_movieSlide__FNcov"};